import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const CONTACT_PHONE = "021 547 054";
export const CONTACT_EMAIL = "freshtoyourdoor.gobox@gmail.com";

export const STATUS_LABELS = {
  pending_payment: "Awaiting payment",
  paid: "Paid",
  packed: "Packed",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg ?? "").filter(Boolean).join(" ");
  return detail?.msg ?? String(detail);
}
